<template>
  <div class="row mb-3 py-3" style="border-bottom: 1px solid #dce2ed;">
    <div class="col col-auto">
      <user-avatar :avatarURL="user.avatar_src"></user-avatar>
    </div>
    <div class="col">
      <a :href="user.detailsUrl" class="row">
        <div class="col">
          <div class="admin-staff-title">{{ user.name }}</div>
          <div class="admin-staff-subtitle">{{ user.subDescription }}</div>
        </div>
        <div class="col col-auto">
          <ForwardChevronIcon fill="#303030"/>
        </div>
      </a>

      <div class="row">
        <div class="col text-right">
          <div class="admin-staff-time">
            {{ minutesToHoursFormatter(user.totalTime) }}
            <span class="cost-due">({{ moneyCurrencyFormatting(user.totalCost, user.currency) }})</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForwardChevronIcon from '@icons/ForwardChevronIcon';
import BarChartIcon from '@icons/BarChartIcon';
import moneyCurrencyFormatting from '../utils/moneyCurrencyFormatting';
import minutesToHoursFormatter from '../utils/minutesToHoursFormatter';

export default {
  props: {
    user: {
      required: true,
      type: Object,
    },
  },

  components: { BarChartIcon, ForwardChevronIcon },

  methods: { moneyCurrencyFormatting, minutesToHoursFormatter },
};
</script>

<style scoped lang="scss">
.admin-staff-title {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}

.admin-staff-subtitle {
  color: #7d8fa6;
  font-family: ".SF NS Display", sans-serif;
  font-size: 10px;
  letter-spacing: 0;
  line-height: 22px;
}

.admin-staff-time {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;

  .cost-due {
    display: inline;
    font-weight: bold;
    color: #0b1324;
  }
}
</style>
